import {
  AUDIENCE_SEGMENTS,
  DIGITAL_STRENGTHS,
  FACEBOOK_BUSINESS_MANAGER_ID,
  GEO_DISTRIBUTION,
  ICON,
  ICON_NAME,
  NAME,
  RH_PLATFORMS
} from '../fields'

export const transformValuesToBE = values => {
  const audienceSegments = values[AUDIENCE_SEGMENTS]
  const filledAudienceSegments = audienceSegments.filter(item => item[0]?.value && item[1]?.value)

  const formattedAudienceSegments = filledAudienceSegments.map(item => ({
    name: item[0].value,
    size: parseInt(item[1].value, 10)
  }))

  const geoDistribution = values[GEO_DISTRIBUTION]
  const filledGeoDistribution = geoDistribution.filter(item => item[0]?.value && item[1]?.value)
  const formattedGeoDistribution = filledGeoDistribution.map(item => ({
    country: item[0].value,
    ratio: parseFloat(item[1].value) / 100 // Convert percentage [0, 100] to ratio [0, 1]
  }))

  const updatedAccount = {
    [NAME]: values[NAME],
    [FACEBOOK_BUSINESS_MANAGER_ID]: values[FACEBOOK_BUSINESS_MANAGER_ID],
    ...(values[ICON] && { [ICON]: values[ICON] }),
    ...(values[ICON_NAME] && { [ICON_NAME]: values[ICON_NAME] }),
    rh_profile: {
      [NAME]: values[NAME],
      [AUDIENCE_SEGMENTS]: formattedAudienceSegments,
      [GEO_DISTRIBUTION]: formattedGeoDistribution,
      [DIGITAL_STRENGTHS]: values[DIGITAL_STRENGTHS],
      [RH_PLATFORMS]: values[RH_PLATFORMS].map(item => item.value)
    }
  }

  return updatedAccount
}
